import { useEffect, useState } from "react";

function getSavedUserID(id,initialID) {
    const savedID = JSON.parse(localStorage.getItem(id));
    if(savedID){
        return savedID
    }else{
        return initialID;
    }
}



export default function LocalStorage2(id,initialID) {
    let[userID,setUserID]= useState(()=>{
       return getSavedUserID(id, initialID);
   });

   useEffect(() =>{
       localStorage.setItem(id,JSON.stringify(userID));
   },[userID,id]);

   return[userID,setUserID];
}